module.exports = __webpack_public_path__ + "img/01_DSC7437.2af17b0a.jpg";